module.exports = __webpack_public_path__ + "static/media/bm_ancherwoman.197fb254.jpg";